module.exports = __webpack_public_path__ + "img/SKMJ_etc7.7b81408e.jpg";